import { ConfigurationOntologyForAutomaticProtocolResponse } from '@/modules/configurationModule/detail/automation/protocols/services/configuration-ontology-for-automatic-protocol/configuration-ontology-for-automatic-protocol.dto'
import { store } from '@/store/store'

export interface ConfigurationAutomationProtocolsModalBasicFormState {
    ontologyForAutomaticProtocol: Partial<ConfigurationOntologyForAutomaticProtocolResponse>
    laboratoryId: number
}
export const initialConfigurationAutomationProtocolsModalBasicFormState =
    (): ConfigurationAutomationProtocolsModalBasicFormState => ({
        ontologyForAutomaticProtocol: {},
        laboratoryId: store.getters.labId
    })
